import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AssociateService } from '../shared/services/associate.service';

@Injectable()
export class ManagementResolver implements Resolve<any> {
    constructor(private associsateService: AssociateService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.associsateService.managementTabInfo(route.params.id);
    }
}
